import React from 'react'
import { Button } from '@mui/material'
import { Modal } from 'react-bootstrap'
import moment from 'moment'

const FindPayments = ({ page, PER_PAGE, myPaymentData, myPaymentsList,
    paymentDetailsModal, setPaymentDetailsModal, filter, handleChange, clear }) => {
    const capitalizeFirstLetter = (str) => {
        if (!str) return ''; // Handle empty or undefined input
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const pageCounts = [10, 20, 40, 60, 80, 100, 140, 180, 200];

    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp * 1000);
        return moment(date).format('DD-MM-YYYY hh:mm A');
    };
    console.log(paymentDetailsModal, 'paymentDetailsModal')
    return (
        <>
            {/* <p>Total Payment : {myPaymentData.totalCount}</p> */}

            <div className="row">
                <div className='mt-4  d-flex col-lg-3 col-md-4'>
                    <h6 className='mt-2'>Start</h6>
                    <h6 className='ms-1 mt-2'>Date</h6>
                    <input className='form-control ms-1' type="date" name="startDate" style={{ height: '37px' }} onChange={(e) => handleChange(e)} value={filter.startDate || ''} />

                </div>
                <div className='mt-4 d-flex col-lg-3  col-md-4'>
                    <h6 className='mt-2'>End</h6>
                    <h6 className='ms-1 mt-2'>Date</h6>
                    <input className='form-control ms-1' type="date" name="endDate" style={{ height: '37px' }} onChange={(e) => handleChange(e)} value={filter.endDate || ''} />
                </div>
                <div className='col-lg-2 col-md-4'>
                    <label className="form-label"></label>
                    <select className='form-select' name='type' value={filter.type} onChange={(e) => handleChange(e)}>
                        <option value="" hidden>Type</option>
                        <option value="STRIPE">Stripe</option>
                        <option value="RAZORPAY">Razorpay</option>
                    </select>
                </div>
                <div className='col-lg-2 col-md-4'>
                    <label className="form-label"></label>
                    <select className='form-select' name='pageCount' value={filter.pageCount} onChange={(e) => handleChange(e)}>
                        <option value="" hidden>Page Count</option>
                        {pageCounts.map((count) => (
                            <option key={count} value={count}>
                                {count}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-lg-2 col-md-4 d-flex ">
                    <button type="submit" className="btn btn-primary  px-3 my-4 m-2" onClick={() => myPaymentsList()}>Search</button>
                    <button type="button" className="btn btn-dark  px-4 my-4" onClick={() => clear()}>Reset</button>
                </div>
            </div>
            <table className="table  shadow mt-3">
                <thead className="table-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Method</th>
                        <th scope="col">Payment Status</th>
                        <th scope="col">Description</th>
                        <th scope="col">Created At</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        !myPaymentData?.data?.length ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                            :
                            <>
                                {
                                    myPaymentData.data?.map((item, index) => {
                                        return <>
                                            <tr key={index}>
                                                <th style={{ padding: '0.4rem .5rem' }} scope="row">{PER_PAGE * (page - 1) + index + 1}</th>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.currency === 'INR' ? '₹' : '$'} {item.amount}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{capitalizeFirstLetter(item.method)||'Card'}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item.status==='captured'?'Paid':capitalizeFirstLetter(item.status)}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item.description}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{formatTimestamp(item.created_at||item?.created)}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>
                                                    <>
                                                        <Button variant="text" sx={{ color: 'black', fontSize: '12px' }} id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <i className="fa-solid fa-ellipsis-vertical cursor"></i>
                                                        </Button>
                                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                            <a className="dropdown-item cursor" onClick={() => setPaymentDetailsModal((pre) => ({ ...pre, open: true, data: item }))}>View</a>
                                                        </ul>
                                                    </>
                                                </td>
                                            </tr>
                                        </>
                                    })
                                }
                            </>
                    }
                </tbody>
            </table>


            {/* Payment Details View Modal */}

            <Modal size="lg" centered show={paymentDetailsModal?.open} onHide={() => setPaymentDetailsModal({ open: false, data: {} })}>
                <div className='m-3 modal-lg'>
                    <div style={{ minHeight: '15vh' }}>
                        <div className='d-flex justify-content-end mb-2 text-center'>
                            <i className="fa-solid fa-xmark cursor" onClick={() => { setPaymentDetailsModal({ open: false, data: {} }); }}></i>
                        </div>
                        <div style={{ border: '1px solid #b3b3b3', borderRadius: '5px', padding: '10px' }}>
                            <div>
                                <div className="row">
                                    {
                                        paymentDetailsModal?.data?.status === 'failed' ?
                                            <div className="col-md-12">
                                                <label htmlFor="recipient-name" className="col-form-label">Description</label>
                                                <textarea className='form-control' disabled  name="startDate" value={paymentDetailsModal?.data?.error_description}></textarea>
                                                {/* <input className='form-control' disabled type="text" name="startDate" value={paymentDetailsModal?.data?.acquirer_data?.bank_transaction_id} /> */}
                                            </div>
                                            :
                                            paymentDetailsModal?.data?.method === 'card' ?
                                                <>
                                                    <div className="col-md-6">
                                                        <label htmlFor="recipient-name" className="col-form-label">Entity</label>
                                                        <input className='form-control' disabled type="text" name="startDate" value={capitalizeFirstLetter(paymentDetailsModal?.data?.card?.entity)} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label htmlFor="recipient-name" className="col-form-label">Issuer</label>
                                                        <input className='form-control' disabled type="text" name="startDate" value={paymentDetailsModal?.data?.card?.issuer} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label htmlFor="recipient-name" className="col-form-label">Last 4 No</label>
                                                        <input className='form-control' disabled type="text" name="endDate" value={`**** **** **** ${paymentDetailsModal?.data?.card?.last4}`} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label htmlFor="recipient-name" className="col-form-label">Network</label>
                                                        <input className='form-control' disabled type="text" name="endDate" value={paymentDetailsModal?.data?.card?.network} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label htmlFor="recipient-name" className="col-form-label">Type</label>
                                                        <input className='form-control' disabled type="text" name="startDate" value={paymentDetailsModal?.data?.card?.type} />
                                                    </div>
                                                </>
                                                : paymentDetailsModal?.data?.method === 'upi' ?
                                                    <>
                                                        <div className="col-md-6">
                                                            <label htmlFor="recipient-name" className="col-form-label">RRN No</label>
                                                            <input className='form-control' disabled type="text" name="startDate" value={paymentDetailsModal?.data?.acquirer_data?.rrn} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="recipient-name" className="col-form-label">Payer Account Type</label>
                                                            <input className='form-control' disabled type="text" name="startDate" value={paymentDetailsModal?.data?.upi?.payer_account_type} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="recipient-name" className="col-form-label">VPA</label>
                                                            <input className='form-control' disabled type="text" name="startDate" value={paymentDetailsModal?.data?.upi?.vpa} />
                                                        </div>
                                                    </>
                                                    : paymentDetailsModal?.data?.method === 'netbanking' ?
                                                        <div className="col-md-12">
                                                            <label htmlFor="recipient-name" className="col-form-label">Bank Transaction ID</label>
                                                            <input className='form-control' disabled type="text" name="startDate" value={paymentDetailsModal?.data?.acquirer_data?.bank_transaction_id} />
                                                        </div>
                                                        :
                                                        <>
                                                        <div className="col-md-6">
                                                            <label htmlFor="recipient-name" className="col-form-label">Brand</label>
                                                            <input className='form-control' disabled type="text" name="startDate" value={paymentDetailsModal?.data?.payment_method_details?.card?.brand} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="recipient-name" className="col-form-label">Last 4 No</label>
                                                            <input className='form-control' disabled type="text" name="startDate" value={paymentDetailsModal?.data?.payment_method_details?.card?.last4} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="recipient-name" className="col-form-label">Exp Month</label>
                                                            <input className='form-control' disabled type="text" name="startDate" value={paymentDetailsModal?.data?.payment_method_details?.card?.exp_month} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="recipient-name" className="col-form-label">Exp Year</label>
                                                            <input className='form-control' disabled type="text" name="startDate" value={paymentDetailsModal?.data?.payment_method_details?.card?.exp_year} />
                                                        </div>
                                                        
                                                        </>
                                                        
                                    }



                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </Modal>


        </>
    )
}

export default FindPayments